var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._b({ref:"slider3",model:{value:(_vm.demo.demo3.value),callback:function ($$v) {_vm.$set(_vm.demo.demo3, "value", $$v)},expression:"demo.demo3.value"}},'vue-slider',_vm.demo.demo3,false))}
var staticRenderFns = []

export { render, staticRenderFns }